// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vZaiG","question":"styles_question__2dxeY","description":"styles_description__2er66"};